import { render } from "./BananoShape.vue?vue&type=template&id=4a7fd5bb&scoped=true"
import script from "./BananoShape.vue?vue&type=script&lang=ts"
export * from "./BananoShape.vue?vue&type=script&lang=ts"

import "./BananoShape.vue?vue&type=style&index=0&id=4a7fd5bb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a7fd5bb"

export default script